import { CommonAPIService } from "src/servicehandlers/CommonHandler";

export class ActiveStudentsAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  get(router) {
    const url = `/api/activeStudents`;
    return this.CommonAPIService.getCall(url, "", router);
  }

  getAllStudentDetails(router) {
    const url = `/api/activeStudents/allStudentsDetails`;
    return this.CommonAPIService.getCall(url, "", router);
  }

  getAvailableStudentsToClasses(router){
    const url = `/api/activeStudents/available`
    return this.CommonAPIService.getCall(url, '', router)
  }

  getStudentById(userId, router) {
    const url = `/api/activeStudents/${userId}`;
    return this.CommonAPIService.getCall(url, "", router);
  }

  create(formData) {
    const url = "/api/activeStudents";
    return this.CommonAPIService.newFileCall(url, formData);
  }

  delete(userId, router) {
    const url = `/api/activeStudents/${userId}`;
    return this.CommonAPIService.deleteCall(url, null, router);
  }

  update(id, formData) {
    const url = `/api/activeStudents/${id}`;
    return this.CommonAPIService.newFileCall(url, formData);
  }

  getStudentsByInstructorId(userId, router) {
    const url = `/api/activeStudents/instructor/${userId}`;
    return this.CommonAPIService.getCall(url, "", router);
  }

  getStudentsByInstructorUserId(userId, router) {
    const url = `/api/activeStudents/instructorUser/${userId}`;
    return this.CommonAPIService.getCall(url, "", router);
  }

  getStudentByUserId(userId, router) {
    const url = `/api/activeStudents/user/${userId}`;
    return this.CommonAPIService.getCall(url, "", router);
  }

  getDocumentsByUserId(userId, router) {
    const url = `/api/activeStudents/documents/${userId}`;
    return this.CommonAPIService.getCall(url, "", router);
  }

  getStudentGradeDetails(id, router){
    const url = `/api/activeStudents/grades/${id}`
    return this.CommonAPIService.getCall(url, '', router)
  }
}
export default ActiveStudentsAPIService;
